module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "border"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABLE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1-b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapter 1    Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("Chapter 2    Context Is Your Lifeline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3    AAoV: A (Digestible) Mouthful")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4    Learn to Live with Numbers or They’ll Bamboozle You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5    Sampling, Rankings—Often Deceptive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6    Filtering Out the Bull")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7    Thought-Revoking Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8    The Pitchperson Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9    Tactics: Putting NBI into Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10   Conclusions: Becoming a Wiser Citizen and Consumer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0